import classnames from 'classnames/bind'
import Toast from 'components/toast'
import { head, noop } from 'lodash'
import AttachmentClient from 'models/attachment'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import FileSelectorModal from './file_selector_modal'
import styles from './uploadable_textarea.module.scss'

const cx = classnames.bind(styles)

export default class UploadableTextarea extends Component {
  constructor(props) {
    super(props)

    this.state = {
      defaultValue: props.defaultValue,
      isFocused: false,
      isUploading: false,
      isOpened: false
    }
  }

  // fileをuploadしてmarkdown形式のtextをinsertする
  handleUpload(file) {
    const { fileSizeLimit } = this.props
    const isSizeOver = file.size > fileSizeLimit
    const isOpened = fileSizeLimit > 0 ? isSizeOver : false
    if (isOpened) {
      this.setState({ isOpened: true })
      return
    }

    this.setState({
      isUploading: true
    })

    AttachmentClient.upload(file)
      .then(data => {
        const line = `![image](${data.path})`
        const cursor = this.textarea.selectionStart
        const currentText = this.textarea.value
        const newText = `${currentText.substr(0, cursor)}${line}${currentText.substr(cursor)}`

        this.textarea.value = newText
        this.handleChangeInput()
        this.setState({
          isUploading: false
        })
      })
      .catch(() => {
        Toast.notify(I18n.t('components.uploadable_textarea.message.upload.failure'))
        this.setState({
          isUploading: false
        })
      })
  }

  handleDropAttachment(e) {
    e.preventDefault()

    const file = head(e.dataTransfer.files)
    this.handleUpload(file)
  }

  handleUploadAttachment(e) {
    e.preventDefault()

    const file = head(e.target.files)
    this.handleUpload(file)
  }

  handleChangeInput() {
    const { onChange } = this.props
    this.setState(
      {
        defaultValue: this.textarea.value
      },
      () => {
        onChange(this.textarea.value)
        this.fileInput = null
      }
    )
  }

  handleFocus(isFocused) {
    this.setState({
      isFocused
    })
  }

  closeModal() {
    this.setState({
      isOpened: false
    })
  }

  render() {
    const { formName, formId, hasError, rows, placeholder, fileSizeLimit } = this.props
    const { defaultValue, isFocused, isUploading, isOpened } = this.state

    return (
      <div className={styles.textarea}>
        <textarea
          ref={ref => {
            this.textarea = ref
          }}
          name={formName}
          id={formId}
          className={cx(styles.formControl, { formControlHasError: hasError })}
          defaultValue={defaultValue}
          placeholder={placeholder}
          disabled={isUploading}
          rows={rows}
          onChange={e => this.handleChangeInput(e)}
          onFocus={() => this.handleFocus(true)}
          onBlur={() => this.handleFocus(false)}
          onDrop={e => this.handleDropAttachment(e)}
          onDragOver={e => e.preventDefault()}
        />
        <div
          className={cx(styles.dragAndDrop, {
            dragAndDropFocused: isFocused && !hasError,
            dragAndDropHasError: hasError
          })}
        >
          {isUploading ? (
            <Fragment>
              <div className={styles.uploadingCircle} />
              {I18n.t('components.uploadable_textarea.message.uploading')}
            </Fragment>
          ) : (
            <Fragment>
              <input
                ref={ref => {
                  this.fileInput = ref
                }}
                accept=".jpg, .jpeg, .png, .gif"
                type="file"
                className={styles.fileInput}
                onChange={e => this.handleUploadAttachment(e)}
              />
              {/* eslint-disable-next-line react/no-danger */}
              <div dangerouslySetInnerHTML={{ __html: I18n.t('components.uploadable_textarea.message.insert_html') }} />
            </Fragment>
          )}
        </div>
        <FileSelectorModal isOpened={isOpened} onClick={() => this.closeModal()} fileSizeLimit={fileSizeLimit} />
      </div>
    )
  }
}

UploadableTextarea.propTypes = {
  defaultValue: PropTypes.string,
  formId: PropTypes.string,
  formName: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fileSizeLimit: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
}

UploadableTextarea.defaultProps = {
  defaultValue: null,
  formId: null,
  hasError: false,
  rows: 10,
  fileSizeLimit: 0,
  onChange: noop,
  placeholder: null
}
